import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs';
import { Action } from '@ngrx/store';
import { tap } from 'rxjs/operators';

import { initPackageLocalStorageAction } from '@app/store/actions/local-storage.actions';
import {
  resetPackageSelectedOptionsAction, setAirSelectedAction,
  setAirSelectedDesktopAction, setHotelRoomSelectedAction,
  setPackageBaseUrlResultAction
} from '@packages/packages-result/store/actions/packages-result.actions';
import { LocalStorageService } from '@app/services/local-storage.service';

@Injectable()
export class LocalStorageEffect {

  constructor(
    private readonly action$: Actions,
    private readonly service: LocalStorageService
  ) { }

  initPackageLocalStorage$: Observable<Action> = createEffect(() => this.action$
    .pipe(
      ofType(initPackageLocalStorageAction),
      tap(action => {
        const { airSelected, data } = action;
        this.service.setEncodePackageAirSelected(airSelected);
        this.service.setEncodePackageSearch(data);
      })
    ), {
    dispatch: false
  });

  setAirSelectedDesktop$: Observable<Action> = createEffect(() => this.action$
    .pipe(
      ofType(setAirSelectedDesktopAction),
      tap(action => {
        const { payload } = action;
        this.service.setEncodePackageAirSelected(payload);
      })
    ), {
    dispatch: false
  });

  setAirSelected$: Observable<Action> = createEffect(() => this.action$
    .pipe(
      ofType(setAirSelectedAction),
      tap(action => {
        const { payload } = action;
        this.service.setEncodePackageAirSelected(payload);
      })
    ), {
    dispatch: false
  });

  setHotelRoomSelected$: Observable<Action> = createEffect(() => this.action$
    .pipe(
      ofType(setHotelRoomSelectedAction),
      tap(action => {
        this.service.setEncodePackageRateHotelId(action.id);
      })
    ), {
    dispatch: false
  });

  setPackageBaseUrlResult$: Observable<Action> = createEffect(() => this.action$
    .pipe(
      ofType(setPackageBaseUrlResultAction),
      tap(action => {
        this.service.setEncodePackageBaseUrlResult(action.url);
      })
    ), {
    dispatch: false
  });

  resetPackageSelectedOptions$: Observable<Action> = createEffect(() => this.action$
    .pipe(
      ofType(resetPackageSelectedOptionsAction),
      tap(() => {
        this.service.removeAllPackageData();
      })
    ), {
    dispatch: false
  });

}
